import Bestellung from "@/entities/common/bestellung"
import BaseLogic from "../base_logic"

export default class DetailsLogic extends BaseLogic {
  bestellung: Bestellung = null

  init(window: Window) {
    this.bestellung = this.mainLogic.bestellung
    this.mainLogic.bestellungListeners.push(() => {
      this.bestellung = this.mainLogic.bestellung
      // window.document.getElementById("bestellung-container").scrollTo(0, 0)
    })
  }
}
